import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    customQuestion: {
      '3212Z': 'Specify the main raw materials you use.',
      '4329A':
        'Specify if your activity includes the following insulation services: Certificats d’Economie d’Energie CEE), MaPrimeRénov ou Isolation à 1 €.',
      '4618Z': 'Specify the type of products or services you offer.',
      '4619B': 'Specify the type of products or services you offer.',
      '4778C': 'Specify the type of products or services you offer.',
      '4791A': 'Specify the type of products or services you offer.',
      '4791B': 'Specify the type of products or services you offer.',
      '4799A': 'Specify the type of products or services you offer.',
      '7022Z': 'Specify your field of expertise and the missions you propose.',
      '8559B': 'Specify the field of teaching in which you practice.',
      '8690F': 'Describe your activity. If possible, specify your website.',
      '9609Z':
        'Indicate the services you offer. If possible, specify your website.',
    },
    description:
      'You have indicated that your activity is:\n**«\u00A0{activityType} - {formattedActivityType}\u00A0»**.',
    detailsHelp: '/300 characters',
    genericQuestion:
      'This is a generic activity and includes numerous variants. Could you please tell us about the sector you work in with some examples of projects you will carry out?',
    label: 'Information about your activity',
    nextButtonLabel: 'Continue',
    title: 'About your activity',
  },
  fr: {
    customQuestion: {
      '3212Z': 'Précisez les principales matières premières que vous utilisez.',
      '4329A':
        'Précisez si votre activité inclut les prestations d’isolation suivantes : Certificats d’Economie d’Energie CEE), MaPrimeRénov ou Isolation à 1 €.',
      '4618Z': 'Détaillez le type de produits ou services que vous proposez.',
      '4619B': 'Détaillez le type de produits ou services que vous proposez.',
      '4778C': 'Détaillez le type de produits ou services que vous proposez.',
      '4791A': 'Détaillez le type de produits ou services que vous proposez.',
      '4791B': 'Détaillez le type de produits ou services que vous proposez.',
      '4799A': 'Détaillez le type de produits ou services que vous proposez.',
      '7022Z':
        'Précisez votre domaine d’expertise et les missions que vous proposez.',
      '8559B': 'Précisez le domaine d’enseignement dans lequel vous exercez.',
      '8690F':
        'Indiquez l’activité que vous exercez. Si possible, précisez votre site internet.',
      '9609Z':
        'Indiquez les services que vous proposez. Si possible, précisez votre site internet.',
    },
    description:
      'Vous avez indiqué exercer l’activité suivante\u00A0:\n**«\u00A0{activityType} - {formattedActivityType}\u00A0»**.',
    detailsHelp: '/300 caractères',
    genericQuestion:
      'Cette activité est généraliste et regroupe de nombreuses variantes. Pourriez-vous nous préciser dans quel domaine vous exercez avec quelques exemples de missions que vous allez effectuer\u00A0?',
    label: 'Précisions sur votre activité',
    nextButtonLabel: 'Continuer',
    title: 'Au sujet de votre activité',
  },
});
